/**
 * Pakistani mobile helpers for Emen forms.
 * Canonical: +923XXXXXXXXX  |  Display: +92 3XX XXXXXXX
 */
(function (global) {
  function digits(raw) {
    return String(raw || '').replace(/\D/g, '');
  }

  function normalizeToE164(raw) {
    var d = digits(raw);
    if (!d) return null;
    if (d.indexOf('92') === 0 && d.length === 12 && d.charAt(2) === '3') {
      return '+' + d;
    }
    if (d.charAt(0) === '0' && d.length === 11 && d.charAt(1) === '3') {
      return '+92' + d.slice(1);
    }
    if (d.length === 10 && d.charAt(0) === '3') {
      return '+92' + d;
    }
    return null;
  }

  function isValidPkMobile(raw) {
    return /^\+923\d{9}$/.test(normalizeToE164(raw) || '');
  }

  function formatDisplay(raw) {
    var e164 = normalizeToE164(raw);
    if (!e164) return String(raw || '').trim();
    var d = e164.slice(1); // 923XXXXXXXXX
    return '+92 ' + d.slice(2, 5) + ' ' + d.slice(5);
  }

  global.EmenPhone = {
    normalizeToE164: normalizeToE164,
    isValidPkMobile: isValidPkMobile,
    formatDisplay: formatDisplay,
  };
})(typeof window !== 'undefined' ? window : globalThis);
